import React from "react";
import { Container, Row, Col, Label, Input } from "reactstrap";
import NewsSection from "../../sections/News/News";
import './Contents.css';
import { FilterIcon } from "../../components/Icons";


export default class Content extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            drInfoList: [],
            isLoading: true,
            targetSymbol: 'EVERY_SYMBOL',
            activeTab: 'News',
            openFilter: false
        };

        this.toggleFilter = this.toggleFilter.bind(this);
        this.onSelectDR = this.onSelectDR.bind(this);
        this.onSelectType = this.onSelectType.bind(this);
    }

    async loadContent(url) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data;
        }
        catch {
            console.log("Error");
            return [];
        }
    }

    async loadSymbolData() {
        var url = 'api/Content/GetAllSymbol';
        var result = await this.loadContent(url);
        this.setState({ drInfoList: result !== null ? result : [], isLoading: false });
    }

    async componentDidMount() {
        this.loadSymbolData();
    }

    toggleFilter() {
        var { openFilter } = this.state;
        this.setState({ openFilter: !openFilter })
    }

    onSelectDR(e) {
        console.log(e.target.value);

        if(e.target.value === 'All') {
            this.setState({ targetSymbol: 'EVERY_SYMBOL' });
        } else {
            this.setState({ targetSymbol: e.target.value });
        }
    }

    onSelectType(activeTab) {
        this.setState({ activeTab });
    }

    renderDrInfoList(drInfoList) {
        const filter = (symbolInput) => {
            this.setState({ targetSymbol: symbolInput });
        };

        var { activeTab, openFilter } = this.state;

        return <div>
            <div id="content-section-filter" className="d-block d-md-none" xs={12}>
                <Container>
                    <Row>
                        <Col>
                            <div className="d-flex flex-row">
                                <div className="flex-grow-1 align-self-center">
                                    <span>หุ้น: <b>{this.state.targetSymbol === 'EVERY_SYMBOL' ? 'ทั้งหมด' : this.state.targetSymbol}</b></span>
                                    <span>ประเภท: <b>{activeTab === 'News' ? 'ข่าวสาร' : activeTab === 'Research' ? 'บทวิเคราะห์' : 'ประกาศ'}</b></span>
                                </div>
                                <div>
                                    <button onClick={this.toggleFilter}>
                                        <FilterIcon />
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container id="content-section-list" className="content-section">
                <div id="filter-body" className={`${openFilter === true ? 'active' : ''}`}>
                    <div className="d-flex flex-column h-100">
                        <div className="flex-grow-1">
                            <Label>เลือกหุ้น</Label>
                            <Input type="select" onChange={this.onSelectDR}>
                                {drInfoList.map(dr => <option key={`dr-option-${dr.displayName}`} value={dr.displayName}>{dr.displayName === 'All' ? 'ทั้งหมด' : dr.displayName}</option>)}
                            </Input>
                            <br />
                            <Label>เลือกประเภท</Label>
                            <div>
                                <button onClick={() => this.onSelectType('News')} className={`round-button ${activeTab === 'News' ? 'active' : ''}`}>ข่าวสาร</button>
                                <button onClick={() => this.onSelectType('Research')} className={`round-button ${activeTab === 'Research' ? 'active' : ''}`}>บทวิเคราะห์</button>
                                <button onClick={() => this.onSelectType('Announcement')} className={`round-button ${activeTab === 'Announcement' ? 'active' : ''}`}>ประกาศ</button>
                            </div>
                        </div>
                        <div>
                            <button onClick={this.toggleFilter} className="button-secondary w-100">ค้นหา</button>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col md={3} lg={2} className="d-flex flex-column align-self-stretch align-content-stretch d-none d-md-block">
                        <h2 style={{ whiteSpace: 'nowrap'}}>รายชื่อหุ้น DR</h2>
                        <div className="dr-list-side flex-grow-1">
                            {drInfoList.sort((a, b) => a.displayPriority - b.displayPriority).map((drInfo, idx) => <button key={`dr-list-${idx}`} value={drInfo.symbol} onClick={() => filter(drInfo.symbol)}>
                                {drInfo.displayName}
                            </button>)}
                        </div>
                    </Col>
                    <Col className="d-none d-md-block">
                        <NewsSection className="no-border" hideViewAllButton={true} targetSymbol={this.state.targetSymbol} />
                    </Col>

                    <Col className="d-block d-md-none">
                        <NewsSection className="no-border" hideViewAllButton={true} targetSymbol={this.state.targetSymbol} activeTab={activeTab} showTabs={false} />
                    </Col>
                </Row>
            </Container>
        </div>
    }

    render() {
        if (this.state.isLoading) {
            return <Container className="content-section">
                <Row>
                    <Col md={3} lg={2} className="d-flex flex-column align-self-stretch align-content-stretch">
                        <h2>รายชื่อหุ้น DR</h2>
                        <p><em>Loading ...</em></p>
                    </Col>
                    <Col>
                        <NewsSection className="no-border" hideViewAllButton={true} />
                    </Col>
                </Row>
            </Container>
        }
        return this.renderDrInfoList(this.state.drInfoList);
    }
}
